import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from "@fortawesome/free-regular-svg-icons";
import { library } from '@fortawesome/fontawesome-svg-core';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from './pages/Home';
import About from './pages/About';
// import Products from './pages/Products';
import Contact from './pages/Contact';
import ProductsList from './pages/Products';
import ProductInfo from './pages/ProductInfo';
import ModularBox from "./pages/ModularBoxes";
import ModularBoxInfo from "./pages/ModularBoxInfo";
import "./styles/common.css";
import "./styles/responsive.css";

// Import FontAwesome icons
library.add(fas, far);

function App() {
  return (

    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          {/* <Route path="/products" element={<Products />} /> */}
          <Route path="/contact" element={<Contact />} />
          <Route path="/cable-trays/:type" element={<ProductsList />} />
          <Route path="/product/:type/:code" element={<ProductInfo />} />
          <Route path="/modular-boxes" element={<ModularBox />} />
          <Route path="/modular-boxes/:type" element={<ModularBoxInfo />} />
          <Route path="*" element={<h1 style={{marginTop: '20vh', marginBottom: '30vh', textAlign: 'center'}}>404 - PAGE NOT FOUND</h1>} />
        </Routes>
        <Footer />
      </div>
    </Router>

  );
}

export default App;
